import * as React from "react";

import * as Cmp from "@impero-com/common/utils/comparison";
import { groupBy } from "lodash-es";
import memoizeOne from "memoize-one";

import { Tag, TagCategory, TagsData } from "../types";

import { BaseTagList, BaseTagListProps, TagListMode } from "./baseTagList";

type TagListProps = TagsData & { mode: TagListMode };
type TagsByCategory = Array<{ category: TagCategory; tags: Tag[] }>;

class TagList extends React.Component<TagListProps> {
    render(): React.ReactNode {
        const { tags, tagCategories, mode } = this.props;
        const sortedTagsByCategory = getTagsByCategory(tags, tagCategories);

        const baseProps: BaseTagListProps<Tag, TagCategory> = {
            mode,
            categories: sortedTagsByCategory.map((ct) => ct.category),
            getTags: (category: TagCategory) =>
                sortedTagsByCategory.find(
                    (ct) => ct.category.id === category.id
                )!.tags,
            getCategoryLabel: (category: TagCategory) => category.name,
            getCategoryKey: (category: TagCategory) => category.id,
            getTagLabel: (tag: Tag) => tag.name,
            getTagKey: (_category: TagCategory, tag: Tag) => tag.id,
        };

        return <BaseTagList {...baseProps} />;
    }
}

const getTagsByCategory = memoizeOne(
    (tags: Array<Tag>, tagCategories: Array<TagCategory>): TagsByCategory => {
        const stringCompare = Cmp.string();
        const groupedTags = groupBy(tags, (t) => t.tagCategoryId);
        const tagsByCategory = Object.entries(groupedTags).map(
            ([categoryId, tags]) => {
                const sortedTags = tags.toSorted(
                    Cmp.map((tag) => tag.name, stringCompare)
                );
                return {
                    category: tagCategories.find((tc) => tc.id === categoryId)!,
                    tags: sortedTags,
                };
            }
        );
        return tagsByCategory.toSorted(
            Cmp.map((a) => a.category.name, stringCompare)
        );
    }
);

export { type TagListProps, TagList, getTagsByCategory };
